// extracted by mini-css-extract-plugin
export default {"containerInactive":"AccountInactiveError_containerInactive__tU4wb","margin":"AccountInactiveError_margin__A3lRX"};